import { Link } from 'react-router-dom';
import { IoHome } from "react-icons/io5";

export function PageError() {
    return (
        <section className='page-error py-5 py-lg-0 bg-section-secondary'>
            <div className='page-error__container h-100 container m-auto row'>
                <div className='page-error__image mb-5 mb-lg-0 col-12 col-lg-6 d-flex justify-content-center justify-content-lg-end align-items-center'>
                    <img className='page-error__img' src='./assets/utils/mike-w.png' alt='Imagen de página de error' />
                </div>
                <div className='page-error__text col-12 col-lg-6 d-flex align-items-center'>
                    <div className='page-error__box col-12 col-lg-10 text-center'>
                        <h1 className='page-error__title mb-4'>¡UPS! LA PÁGINA NO SE HA ENCONTRADO.</h1>
                        <h4 className='page-error__subtitle mb-5'>No te preocupes, son gajes del oficio. Prueba volviendo a la página de inicio</h4>
                        <Link className='page-error__button' to='/'>
                            <IoHome className='me-2 mb-1' />
                            Home
                        </Link>
                    </div>
                </div>
            </div>

        </section>
    );
}